import React, { useState } from 'react';
import swal from 'sweetalert';
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { updateApplicationStatus } from '../../Services/applicationService';
import useCompanyStore from '../../../../stores/companyStore';
import { prepareKanbanSettings } from '../../Helpers/kanbanHelper';

const ApplicationButtons = ({ application, btnSize, onStatusRefresh }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const company = useCompanyStore((state) => state.company);

  const buttonDataFromKanbanSettings = () => {
    const parsedKanbanSettings = JSON.parse(company?.kanbanSettings);
    const resultForBtnSettings = prepareKanbanSettings(parsedKanbanSettings);
    return resultForBtnSettings;
  };

  const changeApplicationStatus = (application, newStatus) => {
    swal({
      title: t('common.CONFIRMATION_NEEDED'),
      text: t('applications.CHANGE_APPLICATION_STATE'),
      icon: 'warning',
      buttons: {
        cancel: {
          text: t('common.CANCEL'),
          visible: true,
          closeModal: true,
        },
        confirm: {
          text: t('common.CONFIRM'),
          value: true,
          visible: true,
          closeModal: true,
        },
      },
      dangerMode: true,
    }).then((willChange) => {
      if (willChange) {
        updateApplicationStatusWithValidations(newStatus, application);
      }
    });
  };

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const updateApplicationStatusWithValidations = (newStatus, application) => {
    let tmpId = application.applicationId || application.id;

    updateApplicationStatus(tmpId, newStatus).then(() => {
      onStatusRefresh();
    });
  };

  const composeButton = (application) => {
    let applicationStatusName;

    if (application.applicationStatus || application.applicationStatus === 0) {
      const btnData = buttonDataFromKanbanSettings();
      if (btnData) {
        const obj = Object.values(btnData)?.find((item) => item.id === application?.applicationStatus);
        applicationStatusName = obj?.title;
      }
    } else {
      return <div>{t('common.ERROR_NO_STATUS')}</div>;
    }

    return (
      // TODO: disabled={true} untill you implement additional way to update status, beside the "Kanban way"
      <ButtonDropdown disabled={true} isOpen={isOpen} toggle={toggle}>
        <DropdownToggle caret size={btnSize || 'xs'} outline color="success">
          {applicationStatusName}
        </DropdownToggle>
        <DropdownMenu>{createButtons(buttonDataFromKanbanSettings(), application)}</DropdownMenu>
      </ButtonDropdown>
    );
  };

  const createButtons = (originalObj, application) => {
    if (originalObj) {
      const buttonArray = Object.entries(originalObj).map(([key, value]) => (
        <React.Fragment key={key}>
          <DropdownItem onClick={() => changeApplicationStatus(application, key)}>
            <b>{value.title}</b>
          </DropdownItem>
          <DropdownItem divider />
        </React.Fragment>
      ));

      return buttonArray;
    }
  };

  return composeButton(application);
};

export default ApplicationButtons;
